export default () => ({
  plans: []
})



// WEBPACK FOOTER //
// ./src/app/settings/covenants/form/resources/data.js